import { DsFormTemplateGroupInterface } from '../interfaces/foms-models/ds-form-template-group.interface';

export class DsFormTemplateGroup {
  /**
   * Id of the group right
   */
  id: number;

  /**
   * Id of the form template
   */
  templateId: number;

  /**
   * Name of the group
   */
  name: string;

  /**
   * Whether the group is checked
   */
  checked: boolean;

  /**
   * Creates an instance of DsFormTemplateGroup.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: DsFormTemplateGroupInterface) {
    this.id = jsonData.group_id ? jsonData.group_id : null;
    this.templateId = jsonData.form_template_id ? jsonData.form_template_id : null;
    this.name = jsonData.name ? jsonData.name : '';
    this.checked = jsonData.checked ? jsonData.checked : false;
  }
}
